import { z } from 'zod'

import type {
  BigChapterLectureResponse,
  CommonResponseLectureResponse,
  CommonResponseListBigChapterLectureResponse,
  CommonResponseWatchResponse,
  LectureResponse,
} from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'

import {
  type Lecture,
  type LectureGroup,
  LectureGroupSchema,
  LectureSchema,
  type WatchedLectures,
  WatchedLecturesSchema,
} from './schemas'

// 생성 타입 LectureResponse 는 실제 응답과 세 곳이 어긋난다. 2026-09-16 dev `/lecture/group` 응답으로 확인.
//   1. `curriculum` 이 스펙에 없다. 실제로는 CurriculumConceptCacheDto 모양의 23필드 객체가 온다
//   2. `latestPlayedAt` 이 스펙에 없다. 실제로는 ISO 문자열 또는 null 이 온다
//   3. `videoLengthSeconds` 를 스펙은 Duration 객체로 그리지만 실제로는 초 단위 숫자다
// springdoc 은 컨트롤러가 선언한 클래스를, Jackson 은 런타임 객체를 읽어서 생기는 차이라 FE 가 고칠 수 없다.
// `/lecture/group` 응답도 같은 LectureResponse 를 품으므로 단건·그룹 어댑터가 모두 여기를 거친다.
// 스키마가 실제 모양을 검증하므로 입력은 생성 타입으로 받되 이 한 줄에서만 unknown 을 거친다.
// 백엔드가 선언 타입과 Duration 변환기를 고치면 이 캐스트와 주석만 지운다.
const asWire = (raw: LectureResponse | BigChapterLectureResponse[] | undefined): unknown => raw

export const adaptLecture = (raw: CommonResponseLectureResponse['data']): Lecture =>
  parseApiResponse(LectureSchema, asWire(raw), 'Lecture')

export const adaptLectureGroups = (
  raw: CommonResponseListBigChapterLectureResponse['data'],
): LectureGroup[] => parseApiResponse(z.array(LectureGroupSchema), asWire(raw), 'LectureGroup')

export const adaptWatchedLectures = (raw: CommonResponseWatchResponse['data']): WatchedLectures =>
  parseApiResponse(WatchedLecturesSchema, raw, 'WatchedLectures')
